<template>
  <v-app>
    <core-multi-lang />
    <v-container fill-height fluid grid-list-xl class="main-layout_inner layout-h">
      <v-layout justify-center wrap>
        <!-- inline edit table -->
        <v-flex xs12 class="pt-0">
          <v-flex xs12>
            <h3 class="main_title">
              {{
                $t(
                  "Checkin.resetting-your-password-will-delete-all-the-information-you"
                )
              }}
            </h3>

            <p class="error--text" v-if="apiMessage !== null">{{ apiMessage }}</p>
          </v-flex>

        </v-flex>
      </v-layout>
      <div class="main_btn">
            <v-btn
              block
              class="btn-custom btn-custom-black mb"
              v-on:click="handleBackToChangePassword()"
              >{{ $t("Checkin.return-to-input-screen") }}</v-btn
            >

            <v-btn
              block
              class="btn-custom btn-custom-main"
              v-on:click="handleSubmitForgotPassword()"
              >{{ $t("Checkin.reset") }}</v-btn
            >
          </div>
    </v-container>
  </v-app>
</template>

<style lang="scss">

</style>

<script>
export default {
  data: () => ({
    userId: null,
    rsvId: null,
    addParams: "",
    apiMessage : null
  }),

  computed: {
    changePasswordScreenUrl() {
      return "change-password";
    },
    getEnterCheckinLanguageScreenUrl() {
      return "CheckinLanguage";
    },
  },

  created() {
    
  },

  mounted() {
    this.fetchGuestId();
  },

  methods: {
    fetchGuestId() {
      const userId = this.$store.state.guestReserve.userId;
      const rsvId = this.$store.state.guestReserve.rsvId;

      this.userId = userId
      this.rsvId = rsvId

      if (userId && rsvId) {
        this.addParams =  '/' + rsvId + "?userId=" + userId
      }else{
        this.$router.push('confirm');
      }
    },
    handleBackToChangePassword() {
      this.$router.push(this.changePasswordScreenUrl + this.addParams);
    },

    // 「消去して入力開始」
    //
    // 本人のトークン（パスワード認証済み）を付けて、入力済みの情報を消す。
    // 以前はトークンが無くても、まず無認証の personReset でパスワードを再発行して
    // ログインしていた（宿泊者IDだけで入れた）。無認証の personReset は廃止する
    // （DMS-1268-H）ので、ログインしていなければパスワードの入力と案内の画面へ戻す。
    // 同行者の入口（change-password）から「最初から入力する」を外したので、
    // 通常の導線からこの画面へは来ない。
    handleSubmitForgotPassword() {
      if (!this.$store.state.guestToken) {
        this.handleBackToChangePassword();
        return;
      }
      this.clearAfterLogin().then(() => {
        this.$router.push('/guest-upload-passport');
      });
    },

    // 本人のトークンを付けて呼び、入力済みの情報を消す。
    // 消去に失敗しても手続きは止めない（ゲストを入口で止めるほうが重い）。
    // トークンが無ければ呼ばない＝「データが残る」側に倒す。
    clearAfterLogin() {
      const token = this.$store.state.guestToken
      if (!token) {
        console.log("guestToken が無いため消去をスキップします")
        return Promise.resolve()
      }
      return this.$store
        .dispatch("personReset", { id: this.userId, token })
        .then((res) => {
          // 消した結果を手元の guest にも反映する。次の画面は store の guest を描くので、
          // ここで上書きしないと消えたはずの値が残って見える
          this.$store.commit("setGuestCurrent", {
            ...this.$store.state.guest,
            ...res.data,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss"></style>
